export const REPORT_TYPES = Object.freeze({
  VOTERS_BY_COORDINATOR: 'VOTERS_BY_COORDINATOR',
  VOTERS_BY_LEADER: 'VOTERS_BY_LEADER',
  VOTERS_BY_CLASSIFICATION: 'VOTERS_BY_CLASSIFICATION',
  VOTERS_BY_STATUS: 'VOTERS_BY_STATUS',
  SHEETS_BY_STATUS: 'SHEETS_BY_STATUS',
  CALL_RESULTS: 'CALL_RESULTS',
  SHEET_RESPONSE: 'SHEET_RESPONSE',
  DRIVERS_BY_TYPE: 'DRIVERS_BY_TYPE',
  VEHICLES_BY_COORDINATOR: 'VEHICLES_BY_COORDINATOR',
  VEHICLE_OCCUPANCY: 'VEHICLE_OCCUPANCY',
  VOTERS_NEEDING_VEHICLE: 'VOTERS_NEEDING_VEHICLE',
  DUPLICATES: 'DUPLICATES',
  DAILY_RECORDS: 'DAILY_RECORDS',
  VOTERS_BY_SECTIONAL: 'VOTERS_BY_SECTIONAL',
  COORDINATORS_BY_SECTIONAL: 'COORDINATORS_BY_SECTIONAL',
  LEADERS_BY_SECTIONAL: 'LEADERS_BY_SECTIONAL',
});

export const REPORT_TYPE_LABELS = Object.freeze({
  [REPORT_TYPES.VOTERS_BY_COORDINATOR]: 'Votantes por coordinador',
  [REPORT_TYPES.VOTERS_BY_LEADER]: 'Votantes por puntero',
  [REPORT_TYPES.VOTERS_BY_CLASSIFICATION]: 'Votantes por clasificación',
  [REPORT_TYPES.VOTERS_BY_STATUS]: 'Votantes por estado',
  [REPORT_TYPES.SHEETS_BY_STATUS]: 'Planillas por estado',
  [REPORT_TYPES.CALL_RESULTS]: 'Resultados de llamadas',
  [REPORT_TYPES.SHEET_RESPONSE]: 'Porcentaje de respuesta por planilla',
  [REPORT_TYPES.DRIVERS_BY_TYPE]: 'Conductores por tipo',
  [REPORT_TYPES.VEHICLES_BY_COORDINATOR]: 'Móviles por coordinador',
  [REPORT_TYPES.VEHICLE_OCCUPANCY]: 'Ocupación de móviles',
  [REPORT_TYPES.VOTERS_NEEDING_VEHICLE]: 'Votantes que necesitan móvil',
  [REPORT_TYPES.DUPLICATES]: 'Duplicados',
  [REPORT_TYPES.DAILY_RECORDS]: 'Registros diarios',
  [REPORT_TYPES.VOTERS_BY_SECTIONAL]: 'Votantes por seccional',
  [REPORT_TYPES.COORDINATORS_BY_SECTIONAL]: 'Coordinadores por seccional',
  [REPORT_TYPES.LEADERS_BY_SECTIONAL]: 'Punteros por seccional',
});
